<section class="quem-somos-section">
  <div class="quem-somos-container">

    <h2>Quem Somos</h2>

    <p>
      O CuidaZap nasceu a partir de uma experiência vivida por Patrick Morais,
      profissional de tecnologia, formado em Ciência da Computação pela PUC-SP,
      com anos de experiência na área de tecnologia.
    </p>

    <p>
      Durante uma visita à sua avó, Patrick percebeu algo que ia muito além das
      necessidades do dia a dia. Mesmo tendo filhos e familiares que a amavam e
      se preocupavam com ela, a rotina corrida fazia com que nem sempre estivessem
      presentes como gostariam.
    </p>

    <p>
      Em meio à conversa, Patrick percebeu que sua avó sentia falta de companhia,
      de atenção e de alguém que pudesse estar por perto para ajudá-la em pequenos
      momentos da rotina.
    </p>

    <p>
      Foi então que surgiu uma pergunta:
    </p>

    <p class="destaque">
      “E se ela pudesse ter alguém para ajudar e acompanhar sua rotina, mesmo quando
      a família não pudesse estar por perto?”
    </p>

    <p>
      A partir dessa ideia nasceu o <strong>CuidaZap</strong>.
    </p>


    <h3>Tecnologia transformada em cuidado</h3>

    <p>
      Com sua experiência em tecnologia, Patrick começou a transformar essa ideia
      em uma solução prática, acessível e próxima da realidade das famílias brasileiras.
    </p>

    <p>
      A escolha pelo <strong>WhatsApp</strong> aconteceu de forma natural: uma ferramenta
      que já faz parte da rotina de milhões de pessoas e que permite que o cuidado
      aconteça de maneira simples, sem exigir que o idoso aprenda a utilizar uma
      nova plataforma.
    </p>

    <p>
      O que começou com uma preocupação dentro da própria família se transformou
      em um projeto com um propósito maior: ajudar idosos a terem mais autonomia
      e companhia em sua rotina e, ao mesmo tempo, proporcionar mais tranquilidade
      para seus familiares.
    </p>


    <h3>Por que o CuidaZap existe?</h3>

    <p>
      Sabemos que a vida é corrida. Filhos trabalham, têm compromissos, moram longe
      e nem sempre conseguem estar presentes todos os dias.
    </p>

    <p>
      Mas estar presente não precisa significar estar fisicamente ao lado o tempo inteiro.
    </p>

    <p>
      O CuidaZap nasceu para ajudar a diminuir essa distância e tornar a tecnologia
      uma aliada no cuidado com quem mais importa.
    </p>

    <p class="final-destaque">
      Porque cuidar também é encontrar novas formas de estar presente.
    </p>

  </div>
</section>
